var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _g2, _path0, _g3, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 656,
    height: 548,
    viewBox: "0 0 656 548",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291.53 318.685L192.701 376.94C192.701 376.94 185.885 352.752 205.651 331.971C225.417 310.85 272.786 274.738 272.786 274.738L291.53 318.685Z",
    fill: "#2C5172"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.36 372.512C192.36 372.512 192.019 371.49 191.679 369.445C192.019 373.874 192.701 376.94 192.701 376.94L291.53 318.685L289.826 314.938L192.36 372.512Z",
    fill: "#232739"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M406.716 276.782C406.716 276.782 462.605 315.278 496.003 360.247C496.003 360.247 504.522 376.259 503.5 394.315C503.159 400.447 494.639 396.699 491.913 394.996L371.956 314.256L406.716 276.782Z",
    fill: "url(#paint0_linear_71_18008)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M502.818 388.864C502.478 394.996 493.958 391.249 491.232 389.545L375.023 311.19L371.956 314.256L491.913 394.996C494.639 396.699 502.818 400.447 503.5 394.315C503.841 389.886 503.5 385.798 502.818 381.71C502.818 384.094 502.818 386.479 502.818 388.864Z",
    fill: "#232739"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M351.309 328.592L317.4 325.197L314.887 350.281L348.796 353.676L351.309 328.592Z",
    fill: "#1A3248"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M394.719 266.769L273.057 262L271.012 316.508C270.331 323.662 297.935 335.245 331.332 336.607C364.729 337.97 391.992 330.816 392.333 321.277V320.936H392.674L394.719 266.769Z",
    fill: "#1A3248"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M378.02 345.124L288.733 343.08C284.644 343.08 280.895 346.146 280.554 350.575C278.169 386.346 272.376 545.44 323.153 547.484C376.657 549.528 383.473 392.819 385.517 353.641C386.199 348.872 382.791 345.124 378.02 345.124Z",
    fill: "url(#paint1_linear_71_18008)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_18008)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.085 491.834C470.906 445.88 605 338.485 605 255.414C605 142.452 471.79 82.9721 328.221 82.9721C184.652 82.9721 55.5 166.944 68.0296 277.529C68.0296 357.507 161.239 424.228 283.162 437.484L307.9 462.229C136.501 455.601 0 360.6 0 244.831C0 124.643 146.661 26.9911 328.221 26.9911C509.339 26.9911 656.442 124.643 656.442 244.831C656 368.553 486.809 477.694 314.085 491.834Z",
    fill: "#D5DEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9226 244.831C30.9226 349.995 143.127 440.136 292.439 461.345C128.108 449.415 0 357.065 0 244.831C0 124.643 146.661 26.9911 328.221 26.9911C333.522 26.9911 338.381 26.9911 343.682 27.4329C169.632 32.2935 30.9226 127.736 30.9226 244.831Z",
    fill: "#C8D0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.119 447.205C273.444 433.949 273.002 425.554 269.468 408.321C269.468 408.321 286.696 419.81 303.041 427.321C331.755 440.577 352.075 439.694 352.075 439.694C352.075 439.694 336.614 454.717 307.459 468.415C288.022 477.694 262.842 481.671 262.842 481.671C269.026 471.508 271.235 460.903 272.119 447.205Z",
    fill: "#C8D0E3"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M334.128 317.663C406.966 317.663 466.013 258.636 466.013 185.823C466.013 113.009 406.966 53.9819 334.128 53.9819C261.29 53.9819 202.243 113.009 202.243 185.823C202.243 258.636 261.29 317.663 334.128 317.663Z",
    fill: "url(#paint2_linear_71_18008)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_71_18008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 202,
    y: 54,
    width: 265,
    height: 264
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M437.089 268.41C482.649 211.601 473.515 128.627 416.686 83.0818C359.858 37.5369 276.856 46.6684 231.295 103.478C185.735 160.287 194.87 243.261 251.698 288.806C308.526 334.351 391.529 325.219 437.089 268.41Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_71_18008)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M373.319 227.044C413.873 222.615 456.471 179.009 452.723 127.908",
    stroke: "#232739",
    strokeWidth: 3.40789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_71_18008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 202,
    y: 54,
    width: 265,
    height: 264
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M437.089 268.41C482.649 211.601 473.515 128.627 416.686 83.0818C359.858 37.5369 276.856 46.6684 231.295 103.478C185.735 160.287 194.87 243.261 251.698 288.806C308.526 334.351 391.529 325.219 437.089 268.41Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_71_18008)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M241.093 228.407C209.399 202.856 197.472 142.898 228.143 101.676",
    stroke: "#232739",
    strokeWidth: 3.40789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M397.855 255.32C391.721 289.387 349.463 309.828 304.139 301.651C258.814 293.135 226.78 259.067 233.255 225C239.389 190.933 281.647 170.492 326.971 178.668C372.296 187.185 403.99 221.593 397.855 255.32Z",
    fill: "#D14E3D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M380.816 261.111C375.704 289.387 340.262 306.421 301.753 299.267C263.244 292.453 236.322 263.837 241.434 235.561C246.886 207.285 281.987 189.911 320.497 197.065C359.006 204.219 385.928 233.176 380.816 261.111Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M376.727 261.111C371.956 287.684 338.217 303.696 302.094 296.882C265.629 290.069 240.07 263.155 245.182 236.924C250.294 210.692 283.691 194.339 319.815 201.153C356.279 207.966 381.838 234.88 376.727 261.111Z",
    fill: "url(#paint3_linear_71_18008)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M330.38 258.386C328.676 267.925 316.407 273.716 303.457 271.332C290.507 268.947 280.965 259.067 283.01 249.528C284.714 239.99 296.982 234.198 309.932 236.583C323.223 238.968 332.424 248.847 330.38 258.386Z",
    fill: "url(#paint4_linear_71_18008)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M327.653 258.045C325.949 266.562 315.385 271.672 303.798 269.628C292.211 267.584 284.032 258.727 285.395 250.55C287.099 242.034 297.664 236.924 309.251 238.968C321.178 240.671 329.357 249.528 327.653 258.045Z",
    fill: "#132332"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M292.552 269.969C302.775 275.42 312.317 280.53 309.25 285.981C306.183 291.431 290.166 292.794 278.579 284.618C266.993 276.442 265.97 266.222 270.06 263.496C274.49 260.43 282.328 264.518 292.552 269.969Z",
    fill: "url(#paint5_linear_71_18008)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M271.423 246.462C271.764 251.232 269.378 255.32 265.289 255.661C261.54 256.001 258.132 252.595 257.451 247.825C257.11 243.056 259.495 238.968 263.585 238.627C267.334 238.286 270.741 241.693 271.423 246.462Z",
    fill: "url(#paint6_linear_71_18008)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M378.431 81.9172C377.749 92.1374 359.346 99.2915 337.195 97.9289C315.044 96.5662 297.664 87.368 298.004 77.4885C298.686 67.2683 317.089 60.1141 339.24 61.4768C361.391 62.4988 378.771 71.697 378.431 81.9172Z",
    fill: "url(#paint7_linear_71_18008)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M369.911 80.5545C369.57 88.39 355.257 94.1814 337.877 93.1594C320.838 92.1374 307.206 84.9832 307.547 77.1478C307.888 69.3123 322.201 63.5208 339.581 64.5428C356.961 65.5649 370.593 72.719 369.911 80.5545Z",
    fill: "#07233E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M327.994 78.1698L327.653 84.3019C327.653 87.0273 332.424 89.7527 338.559 90.0934C344.693 90.434 349.805 88.39 349.805 85.6646L350.145 79.5325L327.994 78.1698Z",
    fill: "url(#paint8_linear_71_18008)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M350.145 79.5325C350.145 82.2579 345.033 84.3019 338.899 83.9612C332.424 83.6205 327.653 81.2358 327.994 78.1698C327.994 75.4444 333.106 73.4003 339.24 73.741C345.374 74.0817 350.145 76.8071 350.145 79.5325Z",
    fill: "#D14E3D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_18008",
    x1: 375.347,
    y1: 345.622,
    x2: 497.569,
    y2: 332.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#456785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C5F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_18008",
    x1: 280.623,
    y1: 448.129,
    x2: 394.8,
    y2: 436.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#274D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51728E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_71_18008",
    x1: 428.865,
    y1: 324.762,
    x2: 239.758,
    y2: 46.7582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0433958,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6946,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_71_18008",
    x1: 340.649,
    y1: 184.39,
    x2: 255.04,
    y2: 338.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A3248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#1A3248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885576,
    stopColor: "#406281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C5172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_71_18008",
    x1: 283.083,
    y1: 256.495,
    x2: 330.315,
    y2: 251.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    stopColor: "#6F7487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C8296"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_71_18008",
    x1: 251.002,
    y1: 232.731,
    x2: 307.227,
    y2: 299.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1382,
    stopColor: "#FAFBFB",
    stopOpacity: 0.8618
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2908,
    stopColor: "#EDEEEF",
    stopOpacity: 0.7092
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4502,
    stopColor: "#D7D8DB",
    stopOpacity: 0.5498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6143,
    stopColor: "#B8BABF",
    stopOpacity: 0.3857
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7822,
    stopColor: "#90939B",
    stopOpacity: 0.2178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9508,
    stopColor: "#606470",
    stopOpacity: 0.0492367
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515562",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_71_18008",
    x1: 251.731,
    y1: 232.118,
    x2: 307.957,
    y2: 299.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1382,
    stopColor: "#FAFBFB",
    stopOpacity: 0.8618
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2908,
    stopColor: "#EDEEEF",
    stopOpacity: 0.7092
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4502,
    stopColor: "#D7D8DB",
    stopOpacity: 0.5498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6143,
    stopColor: "#B8BABF",
    stopOpacity: 0.3857
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7822,
    stopColor: "#90939B",
    stopOpacity: 0.2178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9508,
    stopColor: "#606470",
    stopOpacity: 0.0492367
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515562",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_71_18008",
    x1: 298.219,
    y1: 77.4864,
    x2: 378.356,
    y2: 81.8939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    stopColor: "#444853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515562"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_71_18008",
    x1: 335.243,
    y1: 67.1243,
    x2: 345.019,
    y2: 108.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    stopColor: "#444853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515562"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_18008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 656,
    height: 464.843,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 491.834)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/login-image.f13f936a4a5d1c4185834d334d5dcc59.svg";
export { ForwardRef as ReactComponent };